/**
 *
 *  Fichier de function pour l'utilisation de tagmanager et des conversions analytics
 * 
 * */


 /**
 * Objet Completude + gestion de la validation
 */
(function(w) {
    // Définit l'objet Completude
    w.Completude = Object.assign({},w.Completude);   

    /**
     * Envoi à analytique l'information de visualisation d'une page virtuelle     
     */
    w.Completude.TagManager = function(virtualPageUrl,virtualPageview) {
        try {
            if (typeof(dataLayer)!=="undefined") {
                dataLayer.push({
                    'event': 'VirtualPageview',
                    'virtualPageURL': virtualPageview + '-' + virtualPageUrl,
                    'virtualPageTitle': virtualPageview
                });
            }
        }
        catch (e) {
            console.warn("erreur dans w.Completude.TagManager");
        }
    }


    /**
     * Envoi à analytique 'TunnelPageView'
     * ex :  Completude.TagManagerTunnel()  --> Envoi d'un event 'TunnelPageView' avec 'TunnelStep' égal a l'attribut data-step-kpi  de l'étape active
     *       Completude.TagManagerTunnel('nom_etape')  --> Envoi d'un event 'TunnelPageView' avec 'TunnelStep' égal a 'nom_etape'
     *       Completude.TagManagerTunnel('nom_etape',{event : 'DisplayOfferListFull'}) --> Envoi d'un event 'DisplayOfferListFull' avec 'TunnelStep' égal a 'nom_etape'
     */
    w.Completude.TagManagerTunnel = function(step=null, options=null) {
        try {
            if (typeof(dataLayer)!=="undefined") {
                if (step===null)  {
                    // Recherche de l'étape active
                    if ($(".form__step.active[data-step-kpi]").length>0) {
                        step =  $(".form__step.active").data("step-kpi");
                    } else {
                        //Pas de tracking sur cette étape
                        return;
                    }
                }
                var data = Object.assign({
                    'event': 'TunnelPageView',
                    'TunnelStep': step                    
                },options);
                                          
                // Info déjà postulé
                if (Completude.dejaPostule()===true) {
                    data = Object.assign(data,{ 'InfoUserTunnel': 'DejaPostule'})
                }
                // Info agence
                if (window.Completude.agence!==null && typeof(window.Completude.agence)!=='undefined') {
                    data = Object.assign(data, {'agence' : window.Completude.agence.Libelle});
                }
                console.debug('dataLayer.push  step: ' + JSON.stringify(data));                
                dataLayer.push(data);
                $(document).trigger( "data-step-kpi" , [step]);
            }
        }
        catch (e) {
            console.warn("erreur dans w.Completude.TagManagerTunnel");
        }
    }
        

    jQuery(function () {
        
        /** Taggage Analytics  pour le Tunnel Tarif */
        $("#section-bloc-onglets #form-cours-particuliers #field-address").on('focus', function() {
            w.Completude.TagManagerTunnel('demandetarif/step-0',{"data-tracking-kpi": 'famille-cours-particuliers-champ-adresse-ville-cp'});
        })
        $("#section-bloc-onglets #form-cours-particuliers .selectric").selectric().on('change', function() {
            w.Completude.TagManagerTunnel('demandetarif/step-0',{"data-tracking-kpi": 'famille-cours-particuliers-champ-classe'});
        })
        $("#section-bloc-onglets #form-cours-particuliers #btn-voir-mon-tarif").on('click', function() {
            w.Completude.TagManagerTunnel('demandetarif/step-0',{"data-tracking-kpi": 'famille-cours-particuliers-voir-tarif-module-submit'});
        })

        // Tracking clic bouton "Voir mon tarif" , "Tarif Cours particuliers"
        $('a[href="/demande-de-tarifs/"],a[href="'+ document.location.origin+'/demande-de-tarifs/"]').on('click',function() {
            var menu = $(this).closest("header.header").length>0;
            w.Completude.TagManagerTunnel('demandetarif/step-0',{"data-tracking-kpi": 'famille-demande-de-tarifs-cta',"data-tracking-menu": menu});
        });
        
        /** Taggage Analytics pour le Tunnel Demande de Prof */
        $(document).on('data-step-kpi', function(e,step) {
            if (step==='demandeProf/step-1') {
                // Bouton "Demande prof ajouté après un call Ajax"
                $("#btn-demande-prof").on('click',function() {
                    w.Completude.TagManagerTunnel('demandeProf/step-2');
                })
            }
        }) 
        
        // Module 
        
        
        // Clic sur un bouton "Demander un prof particulier"
        $("#btn-demande-prof").on('click',function() {
            w.Completude.TagManagerTunnel('demandeProf/step-2',);
        })

        /** Taggage des bloc de recherche des offres pour le tunnel Offres */
        $("#recherche-offres-form #field-address").on('focus', function(e) {
            w.Completude.TagManagerTunnel('offres/step-0',{"data-tracking-kpi": 'prof-recherche-offres-champ-adresse-ville-cp'});
        })
        $("#recherche-offres-form .dropdown__toggle").on('click', function(e) {
            w.Completude.TagManagerTunnel('offres/step-0',{"data-tracking-kpi": 'prof-recherche-offres-champ-matieres-stage'});
        })

        $("#section-bloc-recherche-offres form,#recherche-offres-form").attr("data-step-kpi","offres/step-0");
        $("#recherche-offres-form #search-offers-block").on('click', function(e) {
            w.Completude.TagManagerTunnel('offres/step-0',{"data-tracking-kpi": 'prof-recherche-offres-trouver-submit'});
        })
        /** Tracking des boutons "postuler" */
        //$("#btn-postuler").on('click',function() {
        $('a[href="/postuler/"],a[href="'+ document.location.origin+'/postuler/"]').on('click',function() {           
            w.Completude.TagManagerTunnel('postuler/step-0',{"data-tracking-kpi": 'prof-postuler-cta'});
        });

        
        /** Module Onglet stage */
        $("#section-bloc-onglets #form-cpg-tab #agency-2-4").selectric().on('selectric-change',function() {
            w.Completude.TagManagerTunnel('tarifStage/step-0',{"data-tracking-kpi": 'famille-stages-champ-ville-onglet'});
            // Liste classe dépendante du choix de la liste des villes --> pas de tracking
            // Liste stage dépendante du choix de la liste classe --> pas de tracking            
        });
               
        $("#section-bloc-onglets #form-cpg-tab #configurator-btn-1").on('click',function() {
            w.Completude.TagManagerTunnel('tarifStage/step-0',{"data-tracking-kpi": 'famille-stages-dates-tarifs-module-onglet-submit'});
        });
        // Changement de la classe sur le module "Actu stage"
        $('#section-bloc-actu-stage #bloc-actu-id-classe').selectric().on('selectric-change',function() {
            w.Completude.TagManagerTunnel('tarifStage/step-0',{"data-tracking-kpi": 'famille-stages-champ-classe-module-actualite'});
        });
                
        // Tunnel stage Tarif (Page stage)
        $('#custom-form-disko #agency').selectric().on('selectric-change',function() {
            if ($('#custom-form-disko #agency').closest('.visioHide').length===0) {
                w.Completude.TagManagerTunnel('tarifStage/step-0',{'data-tracking-kpi':'famille-stages-champ-ville-page-stage'});
            }
        });
        $('#custom-form-disko #field-class-6,#custom-form-disko #field-class-7').selectric().on('selectric-change',function() {
            w.Completude.TagManagerTunnel('tarifStage/step-0',{'data-tracking-kpi':'famille-stages-champ-classe-page-stage'});
        });        
        $('#custom-form-disko #configurator-btn-5,#custom-form-disko #configurator-btn-6').on('click',function() {
            w.Completude.TagManagerTunnel('tarifStage/step-0',{'data-tracking-kpi': 'famille-stages-voir-dates-page-stage-submit'});
        });        
        if ($('#resultStage').length>0) {
            w.Completude.TagManagerTunnel('tarifStage/step-1');
        }
        // Tunnel stage résa
        /** Taggage Analytics pour le Tunnel Reservation stage */
        $(document).on('data-step-kpi', function(e,step) {
            if (step==='tarifStage/step-3') {
                // Fin du tunnel tarif = début du tunnel résa Stage
                w.Completude.TagManagerTunnel('resaStage/step-1');                
            }
            else if (step==='resaStage/step-3') {
                // Fin du tunnel résa stage = début du tunnel paiementStage
                w.Completude.TagManagerTunnel('paiementStage/step-1');                
            }
        })

         /**
        * Taggage des erreurs de saisie
        */
        window.Parsley.on('form:error', function (formInstance) {
            try {
                var $form = $(formInstance.$element);
                var firstErrorElement = $form.find('.error:first');               
                // Tracking des erreur dans les formulaires
                if ($(".form__step.active[data-step-kpi]").length>0) {
                    step =  $(".form__step.active").data("step-kpi");
                } else {
                    step = $form.data("step-kpi");
                }
                Completude.TagManagerTunnel(step,{'event': 'GTMerror', 'ErrorType' : firstErrorElement[0].innerText,'url' : document.location.pathname});
            }
            catch(e) {
                console.info(e);
            }
        })
                
    });

    
        
    // Capte les évènements "Agence Chargée"
    // Envoi un évènement à tagmanager pour déclencher le tracking sur les clics de numéro de téléphone
    jQuery(document).on("agenceLoaded","",function(event,agence) {        
        
        if( typeof(dataLayer) !== 'undefined' && agence!=null ) {
            dataLayer.push({"agence" : agence.Libelle});
            dataLayer.push({"event":"chargement-agence-ok"});
        }
    }); 
    
})(window);

